<template>
  <div class="toolPage">
    <div class="breadcrumb_one flex-rowl">
      <div class="breadcrumb_item">圭基MODEL <span>(Beta 1.1)</span></div>
    </div>
    <div class="container_wrap">
      <div class="tit">选择模型类型<span>(Beta 1.1)</span></div>
      <div class="content_wrap flex-rowc">
        <div class="item flex-rowc" @click="handleDetail">
          <span class="iconfont icon-caidan_jixiaohuaxiang"></span>
          <p>商品图片AI转化生成</p>
        </div>
        <div class="item flex-rowc" @click="handleTaost">
          <span class="iconfont icon-caidan_jixiaohuaxiang"></span>
          <p>木模拍摄AI转化生成</p>
        </div>
        <div class="item flex-rowc" @click="handleTaost">
          <span class="iconfont icon-caidan_jixiaohuaxiang"></span>
          <p>AI换脸</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "toolIndex",
  data() {
    return {};
  },
  methods: {
    handleDetail() {
         this.$router.push("/ToolManageIndex/toolEdit");
    },
    handleTaost() {
      this.$message('接口调试中')
    },
  }
};
</script>

<style lang="less" scoped>
.toolPage {
  padding: 138px 60px 0;
  min-height: 100vh;
  box-sizing: border-box;
  .breadcrumb_one {
    font-size: 30px;
    color: #000000;
    height: 100px;
    span {
      font-size: 16px;
      color: #666666;
    }
  }
  .container_wrap {
    .tit {
      font-size: 22px;
      color: #000000;
      position: relative;
      margin-bottom: 24px;
      margin-top: 30px;
      margin-left: 100px;
      padding-left: 30px;
      span {
        font-size: 16px;
        color: #666666;
      }
      &::before {
        display: inline-block;
        content: "";
        width: 20px;
        height: 10px;
        border-radius: 5px;
        background: #666666;
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .content_wrap {
      .item {
        background: url(../../assets/images/tool_index_bg.png) no-repeat center;
        background-size: cover;
        width: 378px;
        height: 218px;
        position: relative;
        font-size: 20px;
        cursor: pointer;
        .iconfont {
          position: absolute;
          color: #F50630;
          font-size: 30px;
          top: 20px;
          left: 32px;
        }
        &:nth-child(2) {
          margin: 0 40px;
        }
      }
    }
  }
}
</style>